import get from 'lodash.get';
import isEqual from 'lodash.isequal';
import merge from 'lodash.merge';
import omit from 'lodash.omit';

import { handleBucketLogic, convertCohortIdToInteger } from 'lib/handleBucketLogic';
import { configurationEventTypes } from 'events/configuration';

export default function configurationReducer(state = {}, action) {
  switch (action.type) {
    case configurationEventTypes.CONFIG_UPDATE:
      return handleConfigUpdate(state, action);

    case configurationEventTypes.CONFIG_REFRESH_SUCCESS:
      return handleConfigRefreshSuccess(state, action);

    case configurationEventTypes.CONFIG_QUICK_ACTIONS_FETCH_SUCCESS:
      return handleQuickActionsFetchSuccess(state, action);

    case configurationEventTypes.SET_WELCOME_MESSAGE:
      return handleSetWelcomeMessage(state, action);

    case configurationEventTypes.SET_COHORT_ID:
      return handleSetCohortId(state, action);

    default:
      return state;
  }
}

function handleConfigUpdate(state, action) {
  const cohortId = state.cohortId;
  let actionConfig = action.payload;

  // This is temporary to add backwards compatibility for our existing customers
  if (get(actionConfig, 'font')) {
    actionConfig.theme = merge({}, actionConfig.theme, {
      fontLibrary: { primary: actionConfig.font, secondary: actionConfig.font },
    });
  }

  if (get(actionConfig, 'theme.fontLibrary.primary') && !get(actionConfig, 'theme.fontLibrary.secondary')) {
    // if secondary is not set, set it to the primary value. Avoids conditionals
    // all over the code
    actionConfig.theme.fontLibrary.secondary = actionConfig.theme.fontLibrary.primary;
  }

  const config = merge({}, state.config, omit(actionConfig, ['cohortId']));

  return {
    ...state,
    onboardingTypeTestBucket: handleBucketLogic(config.abTestingPercentage, convertCohortIdToInteger(cohortId)),
    // omitting these since we are extracting them below
    config: omitExtractedConfigValues(config),
    customText: updateIfChanged(state.customText, config.customText),
    icons: updateIfChanged(state.icons, config.icons),
    theme: updateIfChanged(state.theme, config.theme),
    _isFetching: false,
  };
}

function handleConfigRefreshSuccess(state, action) {
  // removing 'welcomeMessage' since other actions can update this current value
  return {
    ...state,
    config: merge({}, state.config, omitExtractedConfigValues(action.payload.config, ['welcomeMessage'])),
  };
}

function handleQuickActionsFetchSuccess(state, action) {
  const newState = { ...state };
  newState.config.selfService.quickActions = action.payload.quickActions;

  return newState;
}

function handleSetWelcomeMessage(state, action) {
  const newState = { ...state };
  newState.config.welcomeMessage = action.payload;

  return newState;
}

function handleSetCohortId(state, action) {
  const newState = { ...state };
  newState.cohortId = action.payload;

  return newState;
}

function updateIfChanged(oldValue, newValue) {
  return isEqual(oldValue, newValue) || !newValue ? oldValue : merge({}, oldValue, newValue);
}

function omitExtractedConfigValues(config, extras = []) {
  return omit(config, ['customText', 'icons', 'theme'].concat(extras));
}
